import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { SubmittedOrder } from '../../models/submitted-order';
import { Product } from '../../models/product';
import { DetailPage } from '../detail/detail';


@IonicPage()
@Component({
  selector: 'page-my-order',
  templateUrl: 'my-order.html',
})
export class MyOrderPage {

  order: SubmittedOrder;

  totalPrice: number;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.order = navParams.get('order');
    this.totalPrice = this.order.order_lines.length != 0 
      ? this.order.order_lines.map(x => (x.quantity * x.product.price_excluding_vat)).reduce((x, y) => x + y)
      : 0;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MyOrderPage');
  }

  /**
  * Pushes detail for specified product id.
  */
  private openDetail(item: Product) {
    this.navCtrl.push(DetailPage, { "product": item });
  }

}



// WEBPACK FOOTER //
// ./src/pages/my-order/my-order.ts